import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de InformaciÃ³n Financiera
 * - Tipo de cliente, ingresos, riesgo, fuente de fondos
 * - Extensible para integraciÃ³n con KYC y perfil de riesgo
 */
export default function FinancialInfoSection() {
    return (
        <Box>
            <Typography variant="h6">InformaciÃ³n Financiera</Typography>
            {/* TODO: Formulario de datos financieros */}
            <Typography variant="body2" color="text.secondary">
                Completa o revisa tu informaciÃ³n financiera y perfil de riesgo.
            </Typography>
        </Box>
    );
} 